import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  XAxis,
  YAxis,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { useEffect, useState } from "react";
import axiosInstance from "@/utils/axiosInstance";

const chartConfig = {
  revenue: {
    label: "Revenue",
    color: "hsl(var(--color-chart-dark-green))",
  },
  label: {
    color: "hsl(var(--background))",
  },
} satisfies ChartConfig;

interface Props {
  month: string;
  revenue: number;
}

const MonthlyRevenueChart = ({
  range,
}: {
  range: { startDate: Date; endDate: Date };
}) => {
  const [chartData, setChartData] = useState<Props[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axiosInstance.get<Props[]>(
          `/reports/monthly-revenue`,
          {
            params: {
              startDate: range.startDate.toISOString().split("T")[0],
              endDate: range.endDate.toISOString().split("T")[0],
            },
          },
        );

        const graphData: Props[] = res.data.map((item) => ({
          month: item.month,
          revenue: Number(item.revenue.toFixed(2)),
        }));

        setChartData(graphData);
      } catch (error) {
        console.error("Gabim gjatë marrjes së të dhënave:", error);
      }
    };

    fetchData();
  }, [range]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Monthly Revenue</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <BarChart
            accessibilityLayer
            data={chartData}
            layout="vertical"
            margin={{
              right: 16,
            }}
          >
            <CartesianGrid horizontal={false} />
            <YAxis
              dataKey="month"
              type="category"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              hide
            />
            <XAxis dataKey="revenue" type="number" hide />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent indicator="line" />}
            />
            <Bar
              dataKey="revenue"
              layout="vertical"
              fill="var(--color-chart-dark-green)"
              radius={4}
              className="w-full"
            >
              <LabelList
                dataKey="month"
                position="insideLeft"
                offset={8}
                className="fill-[--color-label]"
                fontSize={12}
              />
              <LabelList
                dataKey="revenue"
                position="right"
                offset={8}
                className="fill-foreground"
                fontSize={12}
              />
            </Bar>
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default MonthlyRevenueChart;
